// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DocumentationFragment-module__tabs___OoMxB {
  padding: 0;
  margin: 15px 0 -1px 40px;
}

.DocumentationFragment-module__wrapper___zocTy {
  height: 100%;
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/fragments/DocumentationFragment/DocumentationFragment.module.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,wBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;AACF","sourcesContent":[".tabs {\n  padding: 0;\n  margin: 15px 0 -1px 40px;\n}\n\n.wrapper {\n  height: 100%;\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs": `DocumentationFragment-module__tabs___OoMxB`,
	"wrapper": `DocumentationFragment-module__wrapper___zocTy`
};
module.exports = ___CSS_LOADER_EXPORT___;
